import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import 'whatwg-fetch';

export const addOrder = createAsyncThunk('orders/verify', async (orderId) => {
    const params = new URLSearchParams(window.location.search);
    try {
        const resp = await fetch(`${process.env.API_URL}/orders/paypal-complete/${orderId}`, {
            method: 'POST',
            body: params,
        }).then(resp => resp.json());
        
        if (resp && resp.success) {
            return resp.data;
        }
    } catch (e) {
        console.error(e);
    }
});

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        loading: 'idle',
        data: [],
        loaded: false,
        loginSignedPayload: '',
    },
    extraReducers: {
        [addOrder.pending]: (state) => {
            state.loading = 'pending';
        },
        [addOrder.fulfilled]: (state, action) => {
            state.loading = 'idle';
            state.data.push(action.payload);
        },
    }
});

export default ordersSlice.reducer;